module.exports = __webpack_public_path__ + "img/stock0.5d4c38e1.png";